import { useState } from "react";
import { HappeningStage } from "./HappeningStage.js";
import { buildHappeningLabItems, type HappeningArtKind } from "./happeningLabItems.js";

const ART_LABEL: Record<HappeningArtKind, string> = {
  sprite: "絵札: スプライト",
  generated: "絵札: 生成画像",
  none: "絵札: なし",
};

const ITEMS = buildHappeningLabItems();

function LabEntry({ id, art, event }: (typeof ITEMS)[number]) {
  const [replay, setReplay] = useState(0);
  return (
    <section className="happening-lab-entry" aria-label={`${id}のプレビュー`}>
      <header className="happening-lab-meta">
        <code>{id}</code>
        <span className={`happening-lab-art is-${art}`}>{ART_LABEL[art]}</span>
        <button type="button" onClick={() => setReplay((count) => count + 1)}>
          再生
        </button>
      </header>
      <div className="happening-lab-stage">
        <HappeningStage key={replay} event={event} />
      </div>
    </section>
  );
}

export function HappeningLab() {
  const missing = ITEMS.filter((item) => item.art === "none");
  return (
    <main className="happening-lab">
      <header>
        <p>開発用・非公開</p>
        <h1>ハプニング演出ラボ</h1>
        <span>
          全{ITEMS.length}件。絵札なし: {missing.map((item) => item.id).join(", ") || "なし"}
        </span>
      </header>
      <div className="happening-lab-grid">
        {ITEMS.map((item) => (
          <LabEntry key={item.id} {...item} />
        ))}
      </div>
    </main>
  );
}
